import { Leaf, Lightbulb, Award } from "lucide-react";
import Reveal from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const VALUE_ICONS = { sustentabilidade: Leaf, inovacao: Lightbulb, excelencia: Award };

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="sobre" data-testid="about-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 sm:px-10 lg:grid-cols-2 lg:gap-20 lg:px-16">
        <Reveal>
          <p className="font-mono-tech text-xs uppercase tracking-[0.35em] text-emerald-600">
            {t.about.eyebrow}
          </p>
          <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-[#07120C] sm:text-4xl lg:text-5xl">
            {t.about.title}
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
            {t.about.p1}
          </p>
          <p className="mt-4 text-base leading-relaxed text-slate-600">{t.about.p2}</p>
          <blockquote className="mt-7 border-l-4 border-emerald-500 pl-5 text-base font-medium italic leading-relaxed text-[#07120C]">
            {t.about.quote}
          </blockquote>

          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {t.about.values.map((value) => {
              const Icon = VALUE_ICONS[value.id];
              return (
                <div
                  key={value.id}
                  data-testid={`about-value-${value.id}`}
                  className="rounded-2xl border border-slate-200 bg-[#F8FAFC] p-5 transition-colors duration-300 hover:border-emerald-500/40"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-500/15">
                    <Icon className="h-5 w-5 text-emerald-600" />
                  </span>
                  <h3 className="font-display mt-3 text-base font-semibold text-[#07120C]">
                    {value.title}
                  </h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-slate-500">{value.desc}</p>
                </div>
              );
            })}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative">
            <div className="overflow-hidden rounded-3xl border border-slate-200 shadow-xl shadow-emerald-900/5">
              <img
                src="/sobre.jpg"
                alt={t.about.imageAlt}
                loading="lazy"
                className="h-[26rem] w-full object-cover lg:h-[32rem]"
              />
            </div>
            <div className="absolute -bottom-6 -left-4 rounded-3xl border border-emerald-500/20 bg-[#07120C] p-6 shadow-2xl sm:-left-8">
              <p className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-emerald-400">
                {t.about.cardEyebrow}
              </p>
              <p className="font-display mt-2 max-w-[220px] text-sm font-semibold leading-snug text-white">
                {t.about.cardText}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
